import { render } from "./Status.vue?vue&type=template&id=062cd994&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "./Status.vue?vue&type=style&index=0&id=062cd994&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062cd994"]])

export default __exports__